export class Separator {
  static readonly EolRegExp = /\r\n|\r|\n/g;
  static readonly EOL = '\r\n';
  static readonly List = ';';
}
